import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

// Grup satırındaki "Faturaya Git" bağlantıları: fatura modalı açılır; ESC / Kaydet / İptal / Sil ile `returnTo` (aynı filtreler) sayfasına dönülür
export default function ClaimInvoiceLinks({ invoices, returnTo, testid }) {
  if (!invoices.length) return null;
  return (
    <span className="inline-flex flex-wrap items-center justify-end gap-1 mr-2 align-middle" data-testid={`${testid}-invoices`} onClick={(e) => e.stopPropagation()}>
      {invoices.slice(0, 3).map((inv) => (
        <Link key={inv.id} to={`/veri-girisi?bolum=fatura&fatura=${inv.id}&don=${encodeURIComponent(returnTo)}`} data-testid={`${testid}-goto-${inv.invoice_no}`}
          title={`${inv.invoice_no} — ${inv.is_draft ? "Taslak" : "Onaylı"} · ${inv.category_name || ""}`}
          className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold uppercase whitespace-nowrap transition-colors ${inv.is_draft ? "bg-amber-600 text-white hover:bg-amber-700" : "bg-emerald-50 text-emerald-800 border border-emerald-300 hover:bg-emerald-100"}`}>
          <ExternalLink className="w-3 h-3" /> Faturaya Git <span className="font-mono font-normal normal-case">{inv.invoice_no}</span>
        </Link>
      ))}
      {invoices.length > 3 && <span className="text-[10px] text-slate-500">+{invoices.length - 3}</span>}
    </span>
  );
}
